import React from 'react';
import SortAscIcon from '@material-ui/icons/ArrowUpward';
import SortDescIcon from '@material-ui/icons/ArrowDownward';
import icons from './icons';

export const LOGIC = {
  AND: 'and',
  OR: 'or',
};

export const IS = {
  IS: 'is',
  NOT: 'not',
};

// ToDo [DFA-54] spread by value types (some for strings, some for numbers, some for dates, etc.)
export const TYPE = {
  NA: 'n/a',
  EQUAL: 'eq',
  CONTAINS: 'contains',
  STARTS_WITH: 'startsWith',
  ENDS_WITH: 'endsWith',
//  GREATER_THAN: 'gt',
//  GREATER_THAN_OR_EQUAL: 'gte',
//  LESS_THAN: 'lt',
//  LESS_THAN_OR_EQUAL: 'lte',
//  RANGE: 'range',
//  REGEX: 'regex',
};

export const TYPE_DATE = {
  NA: TYPE.NA,
  EQUAL: 'eq',
  BEFORE: 'before',
  AFTER: 'after',
  EQUAL_BEFORE: 'equal_before',
  EQUAL_AFTER: 'equal_after',
};

// ToDo [DFA-55] add NOT_EQUAL, NOT_CONTAINS, NOT_STARTS_WITH, NOT_ENDS_WITH types
export const TYPE_SYMBOL = {
  [TYPE.NA]: '-/-',
  [TYPE.EQUAL]: '==',
  [TYPE.CONTAINS]: '=',
  [TYPE.STARTS_WITH]: '^=',
  [TYPE.ENDS_WITH]: '=$',

  [TYPE_DATE.EQUAL]: '==',
  [TYPE_DATE.BEFORE]: '<',
  [TYPE_DATE.AFTER]: '>',
  [TYPE_DATE.EQUAL_BEFORE]: '<=',
  [TYPE_DATE.EQUAL_AFTER]: '>=',
};

export const TYPE_ICON = {
  [TYPE.EQUAL]: icons.EQUAL,
  [TYPE.CONTAINS]: icons.CONTAINS,
  [TYPE.STARTS_WITH]: icons.STARTS_WITH,
  [TYPE.ENDS_WITH]: icons.ENDS_WITH,
  [TYPE.GREATER_THAN]: icons.GREATER_THAN,
  [TYPE.GREATER_THAN_OR_EQUAL]: icons.GREATER_THAN_OR_EQUAL,
  [TYPE.LESS_THAN]: icons.LESS_THAN,
  [TYPE.LESS_THAN_OR_EQUAL]: icons.LESS_THAN_OR_EQUAL,
  [TYPE.RANGE]: icons.CONTAINS,
  [TYPE.REGEX]: icons.CONTAINS,
};

export const TYPE_TITLE = {
  [TYPE.NA]: 'N/A',
  [TYPE.EQUAL]: 'Equal',
  [TYPE.CONTAINS]: 'Contains',
  [TYPE.STARTS_WITH]: 'Starts with',
  [TYPE.ENDS_WITH]: 'Ends with',

  [TYPE_DATE.EQUAL]: 'Equal',
  [TYPE_DATE.BEFORE]: 'Before',
  [TYPE_DATE.AFTER]: 'After',
  [TYPE_DATE.EQUAL_BEFORE]: 'Before or equal',
  [TYPE_DATE.EQUAL_AFTER]: 'After or equal',

  [TYPE.GREATER_THAN]: 'Greate than',
  [TYPE.GREATER_THAN_OR_EQUAL]: 'Greater than or equal',
  [TYPE.LESS_THAN]: 'Less than or equal',
  [TYPE.LESS_THAN_OR_EQUAL]: 'Less than or equal',
  [TYPE.RANGE]: 'Range',
  [TYPE.REGEX]: 'Regex',
};

export const SELECTOR = {
  GROUPED: 'grouped',
  SELECT: 'select',
};

export const SORT = {
  ASC: 'asc',
  DESC: 'desc',
};

export const SORT_TITLE = {
  [SORT.ASC]: 'Ascending',
  [SORT.DESC]: 'Descending',
};

export const SORT_ICON = {
  [SORT.ASC]: <SortAscIcon />,
  [SORT.DESC]: <SortDescIcon />,
};
